import styles from "./TotemHead.module.css";

interface TotemHeadProps {
  question: string;
  compact?: boolean;
}

export function TotemHead({ question, compact = false }: TotemHeadProps) {
  return (
    <div className={`${styles.totemHead} ${compact ? styles.compact : ""}`}>
      <div className={styles.wings}>
        <div className={styles.wingLeft}></div>
        <div className={styles.wingRight}></div>
      </div>
      <div className={styles.head}>
        <div className={styles.eyes}>
          <div className={styles.eye}></div>
          <div className={styles.eye}></div>
        </div>
        <div className={styles.questionContainer}>
          <p className={styles.question}>{question}</p>
        </div>
      </div>
    </div>
  );
}

